/**
 * @generated SignedSource<<58c7d730eae6386199c42fa776d38dd4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type EmailPreloaderQuery$variables = {
  email?: string | null;
};
export type EmailPreloaderQuery$data = {
  readonly hubspotLead: {
    readonly firstName: string | null;
    readonly lastName: string | null;
  } | null;
};
export type EmailPreloaderQuery = {
  response: EmailPreloaderQuery$data;
  variables: EmailPreloaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "concreteType": "HubspotLead",
    "kind": "LinkedField",
    "name": "hubspotLead",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailPreloaderQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmailPreloaderQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "59ec95b0d096b17aef36308c5fc6b8ff",
    "id": null,
    "metadata": {},
    "name": "EmailPreloaderQuery",
    "operationKind": "query",
    "text": "query EmailPreloaderQuery(\n  $email: String\n) {\n  hubspotLead(email: $email) {\n    firstName\n    lastName\n  }\n}\n"
  }
};
})();

(node as any).hash = "e2cc83951352e36b5b757b9a51836dae";

export default node;
